import React from 'react';
import { Instagram, Linkedin, Twitter, Mail } from 'lucide-react';

const Footer: React.FC = () => {
    return (
        <footer className="bg-navy-950 py-12 border-t border-white/[0.05]">
            <div className="max-w-7xl mx-auto px-6">
                <div className="grid md:grid-cols-4 gap-12 mb-12">
                    <div className="col-span-2">
                        <div className="flex items-center gap-2 mb-4">
                            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-brand-cyan to-brand-blue grid place-items-center">
                                <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5 text-white">
                                    <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <span className="text-lg font-bold text-white">
                                AutomateIT<span className="text-brand-cyan">.ng</span>
                            </span>
                        </div>
                        <p className="text-text-muted max-w-sm">
                            Helping businesses scale through intelligent automation, AI agents, and seamless workflow integration.
                        </p>
                    </div>

                    <div>
                        <h4 className="text-white font-bold mb-4">Services</h4>
                        <ul className="space-y-2 text-sm text-text-muted">
                            <li><button type="button" className="hover:text-brand-cyan transition-colors text-left">AI Automation</button></li>
                            <li><button type="button" className="hover:text-brand-cyan transition-colors text-left">Workflow Engineering</button></li>
                            <li><button type="button" className="hover:text-brand-cyan transition-colors text-left">WhatsApp Bots</button></li>
                            <li><button type="button" className="hover:text-brand-cyan transition-colors text-left">CRM Integration</button></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-white font-bold mb-4">Connect</h4>
                        <div className="flex gap-4 mb-4">
                            <button type="button" className="w-10 h-10 rounded-lg bg-white/[0.05] grid place-items-center text-white hover:bg-brand-cyan hover:text-white transition-all">
                                <Instagram className="w-5 h-5" />
                            </button>
                            <button type="button" className="w-10 h-10 rounded-lg bg-white/[0.05] grid place-items-center text-white hover:bg-brand-blue hover:text-white transition-all">
                                <Linkedin className="w-5 h-5" />
                            </button>
                            <button type="button" className="w-10 h-10 rounded-lg bg-white/[0.05] grid place-items-center text-white hover:bg-black hover:text-white transition-all">
                                <Twitter className="w-5 h-5" />
                            </button>
                        </div>
                        <a href="mailto:hello@automateit.ng" className="flex items-center gap-2 text-text-muted hover:text-white transition-colors">
                            <Mail className="w-4 h-4" />
                            hello@automateit.ng
                        </a>
                    </div>
                </div>

                <div className="pt-8 border-t border-white/[0.05] flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-text-muted">
                    <div>
                        &copy; {new Date().getFullYear()} AutomateIt.ng. All rights reserved.
                    </div>
                    <div className="flex gap-6">
                        <button type="button" className="hover:text-white transition-colors">Privacy Policy</button>
                        <button type="button" className="hover:text-white transition-colors">Terms of Service</button>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
